module.exports = __webpack_public_path__ + "static/img/BG@3x.f92eff4b.jpg";